// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"211":"28ab3b33","601":"8bc634ce"}[chunkId] + ".chunk.css";
};